import { render, staticRenderFns } from "./TextViewer.vue?vue&type=template&id=9ca192b4&scoped=true&"
import script from "./TextViewer.vue?vue&type=script&lang=ts&"
export * from "./TextViewer.vue?vue&type=script&lang=ts&"
import style0 from "./TextViewer.vue?vue&type=style&index=0&id=9ca192b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca192b4",
  null
  
)

export default component.exports